<template>
  <v-expansion-panels
          class="mb-4"
  >
    <v-expansion-panel>
      <v-expansion-panel-header> Tìm kiếm nguồn khách hàng</v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-card
                class="ma-0"
                outlined
        >
          <v-list-item class="pa-0" three-line>
            <v-list-item-content class="pa-0">
<!--              <v-list-item-title class="headline mb-2">-->
<!--                Tìm kiếm nguồn khách hàng-->
<!--              </v-list-item-title>-->
              <v-row>
                <v-col
                        cols="12"
                        sm="8"
                >
                  <v-text-field
                          v-model="filterForm.keyword"
                          label="Tìm Kiếm"
                          placeholder="Tìm kiếm theo tên..."
                          clearable
                          @keyup.enter="searchContactSource"
                  />
                </v-col>
                <v-col
                        cols="12"
                        sm="4"
                >
                  <v-autocomplete
                          v-model="filterForm.status"
                          :items="contactSourceStatusOptions"
                          item-text="text"
                          item-value="value"
                          label="Trạng thái"
                          placeholder="Trạng thái nguồn khách hàng"
                          color="primary"
                          clearable
                  />
                </v-col>
              </v-row>
              <div class="text-center mb-4">
                <v-btn
                        class="primary mx-0"
                        @click="searchContactSource"
                >
                  <v-icon>mdi-magnify</v-icon>Tìm kiếm
                </v-btn>
              </div>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>
<script>
  import RepositoryFactory from '../../../repositories/RepositoryFactory'
  import { contactSourceStatusOptions } from '../../../helpers/constants'
  const ContactSourceRepository = RepositoryFactory.get('contact_source')
  export default {
    name: 'ContactSourceFilterForm',
    props: {
      filterForm: {
        default: () => ({}),
      },
    },
    data () {
      return {
        contacts: [],
        contactSourceStatusOptions,
      }
    },
    created () {
    },
    methods: {
      async getContactSourceList () {
        const response = await ContactSourceRepository.list()
        if (_.get(response, 'success', false)) {
          this.contacts = _.get(response, 'data')
        }
      },
      searchContactSource () {
        Bus.$emit('contact-source-list-filter', this.filterForm)
      },
    },
  }
</script>
